import request from '@/utils/request';


// 上报一次按钮点击或页面操作。
export const createActionEvent = (data) => {
  return request.post('/audit/action-event/', data, {
    // 埋点请求本身不再关联当前点击，避免形成错误的操作链路。
    skipActionAudit: true,
    // 埋点不参与页面业务请求的取消和重复请求判断。
    skipPendingRequest: true,
    // 埋点失败不向用户展示业务错误提示。
    silentError: true
  });
};
